import { Axios } from 'utils'
import { ItemResponseType, ListResponseType } from './types'
import {
  TSettingsCategoryWithAttributes,
  TSettingBase,
  TPublicSetting,
} from 'types'

export const useSettingsService = () => {
  const getSettings = async (companyId: number | string) => {
    try {
      const response = await Axios.get<
        ListResponseType<TSettingsCategoryWithAttributes>
      >(`/settings`, {
        params: { company_id: companyId },
      })
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getPublicSettings = async () => {
    try {
      const response = await Axios.get<TPublicSetting[]>('/settings/public')
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateSetting = async (id: number, newValue: string) => {
    try {
      const response = await Axios.put<ItemResponseType<TSettingBase>>(
        `/settings/${id}`,
        null,
        {
          params: { new_value: newValue },
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const bulkUpdateSettings = async (
    updates: { id: number; value: string }[]
  ) => {
    try {
      const response = await Axios.post('/settings/bulk_update', {
        settings: updates,
      })
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getSettings,
    getPublicSettings,
    updateSetting,
    bulkUpdateSettings,
  }
}
